<template>
  <div>
    <div class="px-4 mx-auto max-w-7xl">
      <div class="fixed inset-x-0 top-0 bg-white shadow-sm">
        <div
          class="flex items-center justify-between h-16 px-4 mx-auto lg:h-20 max-w-7xl"
        >
          <img class="h-8" alt="logo" src="../assets/logo.svg" />
          <div class="lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-7 h-7"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </div>
          <div class="items-center hidden space-x-8 lg:flex">
            <a
              class="py-2 font-bold duration-300 border-b-2 hover:border-b-2 hover:border-primary"
              href="#feats"
              >Преимущества</a
            >
            <button
              type="button"
              @click="goto('form')"
              class="inline-flex items-center px-3 py-1.5 border border-transparent text-base font-bold rounded-md shadow-sm text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
            >
              Связаться
            </button>
          </div>
        </div>
      </div>
      <div
        class="flex flex-col items-center justify-around pt-20 lg:h-screen lg:flex-row lg:pt-16"
      >
        <div class="w-full lg:w-2/3 lg:mr-12">
          <h2
            class="mt-4 text-3xl font-black leading-10 lg:mt-0 md:text-3xl xl:text-4.5xl xl:leading-snug"
          >
            Получите свое
            <span class="text-primary whitespace-nowrap"> QR-меню</span>,
            упростите рабочий процесс
          </h2>
          <p
            class="mt-6 leading-8 text-gray-600 2xl:leading-9 xl:mt-8 2xl:text-lg"
          >
            Обеспечьте безопасность своих клиентов, приложите свои усилия, чтобы
            спасти нашу планету, сэкономьте силы и время официантов, будьте в
            тренде. Присоединяйтесь к нам прямо сейчас!
          </p>
          <button
            @click="goto('form')"
            type="button"
            class="inline-flex items-center px-4 lg:px-6 py-2.5 mt-10 text-base font-bold text-white border border-transparent rounded-md shadow-sm lg:py-3 xl:mt-16 bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            Оставить заявку
          </button>
        </div>
        <div class="mt-10">
          <img
            class="object-cover"
            src="../assets/hero.webp"
            alt="hero image"
          />
        </div>
      </div>
      <section
        id="feats"
        class="flex items-center justify-center pt-16 lg:h-screen"
      >
        <div class="mt-12 lg:hidden">
          <h2 class="text-2xl font-black text-center">Наши преимущества</h2>
          <div class="flex flex-col items-center mt-10">
            <div class="flex space-x-4 overflow-x-auto" style="width: 90vw">
              <div class="pb-2" style="min-width: 220px">
                <div class="w-3 h-3 bg-yellow-200 rounded-full"></div>
                <h3 class="my-3 text-lg font-bold">Экологично</h3>
                <p class="text-sm text-gray-600">
                  Создавая QR-меню, вы сократите использование бумаги и поможете
                  спасти нашу планету
                </p>
              </div>
              <div class="pb-2" style="min-width: 220px">
                <div class="w-3 h-3 bg-red-200 rounded-full"></div>
                <h3 class="my-3 text-lg font-bold">
                  Экономия средств на печати
                </h3>
                <p class="text-sm text-gray-600">
                  Вы сэкономите больше денег, чем распечатайте бумажное меню и
                  потратите его на другие нужды
                </p>
              </div>
              <div class="pb-2" style="min-width: 220px">
                <div class="w-3 h-3 bg-blue-200 rounded-full"></div>
                <h3 class="my-3 text-lg font-bold">Безопасно и гигиенично</h3>
                <p class="text-sm text-gray-600">
                  Получите информацию о еде, не касаясь бумаги меню, и снизьте
                  риск заражения вирусом
                </p>
              </div>
              <div class="pb-2" style="min-width: 220px">
                <div class="w-3 h-3 bg-yellow-200 rounded-full"></div>
                <h3 class="my-3 text-lg font-bold">Легкий доступ</h3>
                <p class="text-sm text-gray-600">
                  У каждого может быть свое меню, независимо от количества
                  клиентов и не дожидаясь официанта
                </p>
              </div>
              <div class="pb-2" style="min-width: 220px">
                <div class="w-3 h-3 bg-red-200 rounded-full"></div>
                <h3 class="my-3 text-lg font-bold">24/7 Поддержка</h3>
                <p class="text-sm text-gray-600">
                  Изменения в меню (изображение еды, цена, категория и т. Д.)
                  можно в любое время
                </p>
              </div>
              <div class="pb-2" style="min-width: 220px">
                <div class="w-3 h-3 bg-blue-200 rounded-full"></div>
                <h3 class="my-3 text-lg font-bold">Мобилность</h3>
                <p class="text-sm text-gray-600">
                  Меню может иметь множество категорий и может быть сформировано
                  на любых языках по вашему желанию, возможно включение филиалов
                  ресторана
                </p>
              </div>
            </div>
            <img
              class="object-cover w-3/4 my-10"
              src="../assets/feats.webp"
              alt="features image"
            />
          </div>
        </div>
        <div class="hidden lg:block">
          <h2 class="text-3xl font-black text-center">Наши преимущества</h2>
          <div class="mt-24">
            <div class="flex items-center space-x-6">
              <div class="flex-1">
                <div class="flex flex-col items-end mb-16 space-y-4">
                  <div class="w-4 h-4 bg-yellow-200 rounded-full"></div>
                  <h3 class="text-2xl font-bold text-right">Экологично</h3>
                  <p class="text-right text-gray-600">
                    Создавая QR-меню, вы сократите использование бумаги и
                    поможете спасти нашу планету
                  </p>
                </div>
                <div class="flex flex-col items-end mb-16 space-y-4">
                  <div class="w-4 h-4 bg-red-200 rounded-full"></div>
                  <h3 class="text-2xl font-bold text-right">
                    Экономия средств на печати
                  </h3>
                  <p class="text-right text-gray-600">
                    Вы сэкономите больше денег, чем распечатайте бумажное меню и
                    потратите его на другие нужды
                  </p>
                </div>
                <div class="flex flex-col items-end space-y-4">
                  <div class="w-4 h-4 bg-blue-200 rounded-full"></div>
                  <h3 class="text-2xl font-bold text-right">
                    Безопасно и гигиенично
                  </h3>
                  <p class="text-right text-gray-600">
                    Получите информацию о еде, не касаясь меню, и снизьте риск
                    заражения вирусом
                  </p>
                </div>
              </div>
              <img
                class="object-cover w-5/12"
                src="../assets/feats.webp"
                alt="features image"
              />
              <div class="flex-1">
                <div class="flex flex-col mb-16 space-y-4">
                  <div class="w-4 h-4 bg-yellow-200 rounded-full"></div>
                  <h3 class="text-2xl font-bold">Легкий доступ</h3>
                  <p class="text-gray-600">
                    У каждого может быть свое меню, независимо от количества
                    клиентов и не дожидаясь официанта
                  </p>
                </div>
                <div class="flex flex-col mb-16 space-y-4">
                  <div class="w-4 h-4 bg-red-200 rounded-full"></div>
                  <h3 class="text-2xl font-bold">24/7 Поддержка</h3>
                  <p class="text-gray-600">
                    Изменения в меню (изображение еды, цена, категория и т.д.)
                    можно в любое время
                  </p>
                </div>
                <div class="flex flex-col space-y-4">
                  <div class="w-4 h-4 bg-blue-200 rounded-full"></div>
                  <h3 class="text-2xl font-bold">Мобильность</h3>
                  <p class="text-gray-600">
                    Меню может иметь множество категорий и может быть
                    сформировано на любых языках по вашему желанию, возможно
                    включение филиалов ресторана
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <ValidationObserver v-slot="{ handleSubmit }" slim>
      <form
        ref="form"
        novalidate
        id="form"
        class="px-4 py-16 lg:py-40"
        @submit.prevent="handleSubmit(sendToChannel)"
      >
        <div
          class="p-6 py-12 mx-auto bg-white rounded-lg md:max-w-lg md:px-10 lg:max-w-2xl lg:py-20 lg:px-16"
        >
          <div class="text-center">
            <h2
              class="mb-4 text-2xl font-black text-gray-800 md:mb-5 lg:mb-6 lg:text-3xl"
            >
              Оставьте заявку
            </h2>
            <h6
              class="mb-5 text-sm text-gray-500 lg:mb-10 md:mb-6 md:text-base"
            >
              Вы просто заполняйте форму ниже, а все остальное мы сделаем сами!
            </h6>
          </div>
          <div>
            <ValidationProvider
              name="username"
              rules="required"
              mode="eager"
              v-slot="{ errors, classes }"
            >
              <label for="name" class="block text-sm font-medium text-gray-700"
                >Имя</label
              >
              <div class="my-1">
                <input
                  v-model="username"
                  type="text"
                  name="user_name"
                  id="name"
                  class="block w-full rounded-md shadow-sm lg:py-3 sm:text-sm"
                  :class="classes"
                  placeholder="Фамилия и имя"
                />
              </div>
              <template v-if="classes.dirty || classes.validated">
                <p
                  class="text-sm text-red-600"
                  v-for="error in errors"
                  :key="error"
                >
                  {{ error }}
                </p>
              </template>
            </ValidationProvider>
          </div>
          <div class="mt-4">
            <ValidationProvider
              name="phone"
              :rules="{ required: true, length: 9 }"
              mode="eager"
              v-slot="{ errors, classes }"
            >
              <label for="phone" class="block text-sm font-medium text-gray-700"
                >Телефона</label
              >
              <div class="my-1">
                <the-mask
                  v-model="phone"
                  type="text"
                  name="phone"
                  :mask="'+998 ## ###-##-##'"
                  id="phone"
                  class="block w-full rounded-md shadow-sm lg:py-3 sm:text-sm"
                  :class="classes"
                />
              </div>
              <template v-if="classes.dirty || classes.validated">
                <p
                  class="text-sm text-red-600"
                  v-for="error in errors"
                  :key="error"
                >
                  {{ error }}
                </p>
              </template>
            </ValidationProvider>
          </div>
          <button
            type="submit"
            :disabled="loading"
            class="flex justify-center items-center w-full py-2.5 mt-6 text-base font-bold text-white border border-transparent rounded-md shadow-sm lg:py-3 xl:mt-10 bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            <svg
              v-if="loading"
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5 mr-2 animate-spin"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            Отправить
          </button>
        </div>
      </form>
    </ValidationObserver>
    <div class="bg-primary">
      <div
        class="flex items-center justify-between px-4 py-6 mx-auto max-w-7xl"
      >
        <p class="font-medium text-gray-200">@qrmenus.uz</p>
        <div class="flex items-center space-x-4">
          <a target="_blank" href="https://t.me/qrmenus">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z"
                fill="white"
                stroke="white"
                stroke-width="1.5"
              />
              <path
                d="M5.60531 11.5412L17.1342 7.05491C17.6693 6.85981 18.1366 7.18665 17.9632 8.00326L17.9642 8.00225L16.0012 17.3359C15.8558 17.9976 15.4662 18.1585 14.9211 17.8468L11.9318 15.6232L10.4899 17.0251C10.3305 17.186 10.1959 17.3218 9.88705 17.3218L10.0993 14.2515L15.6395 9.20001C15.8807 8.9858 15.5857 8.86512 15.2679 9.07832L8.42127 13.4289L5.4698 12.4996C4.82908 12.2945 4.81513 11.853 5.60531 11.5412V11.5412Z"
                fill="#304FFE"
              />
            </svg>
          </a>
          <a target="_blank" href="https://www.instagram.com/qrmenus.uz">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.315 2C14.745 2 15.099 2.013 16.123 2.06C17.187 2.109 17.914 2.278 18.55 2.525C19.2175 2.77587 19.8222 3.16936 20.322 3.678C20.8306 4.17777 21.2241 4.7825 21.475 5.45C21.722 6.086 21.891 6.813 21.94 7.877C21.988 8.944 22 9.284 22 12V12.08C22 14.723 21.988 15.067 21.94 16.123C21.891 17.187 21.722 17.914 21.475 18.55C21.2241 19.2175 20.8306 19.8222 20.322 20.322C19.8222 20.8306 19.2175 21.2241 18.55 21.475C17.914 21.722 17.187 21.891 16.123 21.94C15.056 21.988 14.716 22 12 22H11.92C9.277 22 8.933 21.988 7.877 21.94C6.813 21.891 6.086 21.722 5.45 21.475C4.7825 21.2241 4.17777 20.8306 3.678 20.322C3.16936 19.8222 2.77587 19.2175 2.525 18.55C2.278 17.914 2.109 17.187 2.06 16.123C2.013 15.099 2 14.744 2 12.315V11.685C2 9.255 2.013 8.901 2.06 7.877C2.109 6.813 2.278 6.086 2.525 5.45C2.77587 4.7825 3.16936 4.17777 3.678 3.678C4.17777 3.16936 4.7825 2.77587 5.45 2.525C6.086 2.278 6.813 2.109 7.877 2.06C8.901 2.013 9.256 2 11.685 2H12.315ZM12.234 3.802H11.766C9.31 3.802 8.982 3.813 7.959 3.86C6.984 3.905 6.455 4.067 6.102 4.204C5.635 4.386 5.302 4.602 4.952 4.952C4.602 5.302 4.386 5.635 4.204 6.102C4.067 6.455 3.904 6.984 3.86 7.959C3.813 8.982 3.802 9.31 3.802 11.766V12.234C3.802 14.69 3.813 15.018 3.86 16.041C3.905 17.016 4.067 17.545 4.204 17.898C4.386 18.364 4.603 18.698 4.952 19.048C5.302 19.398 5.635 19.614 6.102 19.796C6.455 19.933 6.984 20.096 7.959 20.14C9.013 20.188 9.329 20.198 12 20.198H12.08C14.677 20.198 14.997 20.188 16.04 20.14C17.016 20.095 17.545 19.933 17.898 19.796C18.364 19.614 18.698 19.398 19.048 19.048C19.398 18.698 19.614 18.365 19.796 17.898C19.933 17.545 20.096 17.016 20.14 16.041C20.188 14.986 20.198 14.671 20.198 12V11.92C20.198 9.323 20.188 9.003 20.14 7.96C20.095 6.984 19.933 6.455 19.796 6.102C19.6358 5.66757 19.3802 5.2746 19.048 4.952C18.7254 4.61986 18.3324 4.36426 17.898 4.204C17.545 4.067 17.016 3.904 16.041 3.86C15.018 3.813 14.69 3.802 12.234 3.802ZM12 6.865C12.6743 6.865 13.3421 6.99782 13.9651 7.25588C14.5881 7.51394 15.1542 7.89218 15.631 8.36901C16.1078 8.84584 16.4861 9.41191 16.7441 10.0349C17.0022 10.6579 17.135 11.3257 17.135 12C17.135 12.6743 17.0022 13.3421 16.7441 13.9651C16.4861 14.5881 16.1078 15.1542 15.631 15.631C15.1542 16.1078 14.5881 16.4861 13.9651 16.7441C13.3421 17.0022 12.6743 17.135 12 17.135C10.6381 17.135 9.33201 16.594 8.36901 15.631C7.40601 14.668 6.865 13.3619 6.865 12C6.865 10.6381 7.40601 9.33201 8.36901 8.36901C9.33201 7.40601 10.6381 6.865 12 6.865ZM12 8.667C11.116 8.667 10.2683 9.01815 9.64321 9.64321C9.01815 10.2683 8.667 11.116 8.667 12C8.667 12.884 9.01815 13.7317 9.64321 14.3568C10.2683 14.9818 11.116 15.333 12 15.333C12.884 15.333 13.7317 14.9818 14.3568 14.3568C14.9818 13.7317 15.333 12.884 15.333 12C15.333 11.116 14.9818 10.2683 14.3568 9.64321C13.7317 9.01815 12.884 8.667 12 8.667ZM17.338 5.462C17.6563 5.462 17.9615 5.58843 18.1865 5.81347C18.4116 6.03852 18.538 6.34374 18.538 6.662C18.538 6.98026 18.4116 7.28548 18.1865 7.51053C17.9615 7.73557 17.6563 7.862 17.338 7.862C17.0197 7.862 16.7145 7.73557 16.4895 7.51053C16.2644 7.28548 16.138 6.98026 16.138 6.662C16.138 6.34374 16.2644 6.03852 16.4895 5.81347C16.7145 5.58843 17.0197 5.462 17.338 5.462Z"
                fill="white"
              />
            </svg>
          </a>
          <a target="_blank" href="https://www.facebook.com/qrmenus.uz">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 16.991 5.657 21.128 10.438 21.878V14.891H7.898V12H10.438V9.797C10.438 7.291 11.93 5.907 14.215 5.907C15.309 5.907 16.453 6.102 16.453 6.102V8.562H15.193C13.95 8.562 13.563 9.333 13.563 10.124V12H16.336L15.893 14.89H13.563V21.878C18.343 21.128 22 16.991 22 12Z"
                fill="white"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "HelloWorld",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      loading: false,
      BOT_API: "1825517285:AAH-NB5WAwYqxfU1Mp4LJwdV0vTtZBoiqic",
      chatId: "@qrmenusuz",
      username: "",
      phone: "998",
    };
  },
  computed: {
    payload() {
      return `Имя: ${this.username}\nТелефон: ${this.formattedPhone}`;
    },
    formattedPhone() {
      return `+998 ${this.phone.slice(0, 2)} ${this.phone.slice(
        2,
        5
      )}-${this.phone.slice(5, 7)}-${this.phone.slice(7, 9)}`;
    },
  },
  methods: {
    async sendToChannel() {
      this.loading = true;
      await axios.post(
        `https://api.telegram.org/bot${this.BOT_API}/sendMessage?chat_id=${this.chatId}`,
        null,
        { params: { text: this.payload } }
      );
      this.loading = false;
      this.$swal({
        position: "center-center",
        icon: "success",
        title: "Ваша заявка принята!",
        text: "Мы свяжемся с вами в ближайшее время",
        showConfirmButton: false,
        timer: 5000,
      });
    },
    goto(ref) {
      var element = this.$refs[ref];
      element.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  scroll-behavior: smooth;
}

#form {
  background-image: url("../assets/formbg.webp");

  @apply bg-cover;
}
</style>
